'use strict';
import angular from 'angular';
import { Services } from '../@types/services';
import {
  IFieldOptionQuery,
  IFieldOptionResult
} from '@Shared.Angular/@types/fieldOptions';

angular.module('flowingly.services').factory('fieldService', fieldService);

fieldService.$inject = ['APP_CONFIG', '$http', 'customdbService'];

function fieldService(
  APP_CONFIG: Services.APP_CONFIG,
  $http: angular.IHttpService,
  customdbService: Services.CustomdbService
) {
  const PUBLIC_FORM_API_URI = APP_CONFIG.apiBaseUrl + 'form';

  const service = {
    getFieldOptions
  };

  return service;

  function getFieldOptions(
    forPublicForm: boolean,
    request: IFieldOptionQuery[]
  ) {
    if (forPublicForm) {
      const URI = PUBLIC_FORM_API_URI + '/fields/options';
      return $http.post<IFieldOptionResult[]>(URI, request).then((response) => {
        return response.data;
      });
    } else {
      return customdbService.getFieldOptions(request);
    }
  }
}

export type FieldServiceType = ReturnType<typeof fieldService>;
